/**
 * Route Prefetch Plugin
 *
 * This plugin listens to route changes and triggers prefetch callbacks.
 * The actual prefetch logic is registered from router.js to avoid circular dependencies.
 *
 * Pattern: Callback Registration
 * - Plugin: Lives in store, subscribes to route changes
 * - Handler: Registered from router.js with access to router instance
 * - Benefit: All plugins stay in store.js, no circular dependency
 */

let prefetchHandler = null

/**
 * Register a prefetch handler to be called on route changes
 * This is called from router.js after router is created
 *
 * @param {Function} handler - Function that receives currentRouteName
 */
export function registerPrefetchHandler(handler) {
  prefetchHandler = handler
}

/**
 * Vuex plugin that triggers prefetch on route changes
 */
const routePrefetchPlugin = (store) => {
  store.subscribeAction((action) => {
    if (action.type !== 'routeChangeAction') return
    const { payload } = action
    // Call registered prefetch handler if available
    if (prefetchHandler && payload?.to?.name) {
      prefetchHandler(payload.to.name)
    }
  })
}

export default routePrefetchPlugin
